<div class="row">
    <div class="col-12" style="margin-top: 100px;">
    </div>
</div>

<div class="container mt-3">
    <div class="row">
        <div class="col-12">
            <div class="row align-items-center">
                <div class="col">
                    <div class="d-flex align-items-center">
                        <i class="fas fa-long-arrow-alt-left me-2"></i> 
                        <img src="assets/images/direkt-Icon.jpg" alt="Pure set" class="logo me-2">
                        <p class="dark mb-0">Direkt</p>
                        <span class="ms-2 test-mode">TEST MODE</span>
                    </div>
                </div>
            </div>
            
            <h5 class="text-muted mt-3">
                Pay Direkt
            </h5>
            <h1 class="mb-4">
                $134.00
            </h1>
            <div class="row mb-4">
                <div class="col-1">
                    <img src="assets/images/about-1.jpg" alt="Pure set" class="image">
                </div>
                <div class="col-11">
                    <div class="row">
                        <div class="col-6">
                            <p class="m-0 dark">Pure set</p>
                            <div class="d-flex align-items-center">
                                <p class="mb-0  text-muted">Qty</p>
                                <select class="form-select form-option border-0">
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-6 text-end">
                            <p class="dark">$65.00</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-1">
                    <img src="assets/images/about-1.jpg" alt="Pure set" class="image">
                </div>
                <div class="col-11">
                    <div class="row">
                        <div class="col-6">
                            <p class="m-0 dark">Pure glow cream</p>
                            <div class="d-flex align-items-center">
                                <p class="mb-0 me-2 text-muted">Qty</p>
                                <select class="form-select form-option border-0">
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-6 text-end">
                            <p class="dark m-0">$64.00</p>
                            <p class="text-muted">$32.00 each</p>

                        </div>
                    </div>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-1">
                </div>
                <div class="col-11">
                    <div class="row">
                        <div class="col-6">
                            <p class="dark">Subtotal</p>
                        </div>
                        <div class="col-6 text-end">
                            <p class="dark">$129.00</p>
                        </div>
                        <div class="bordered-element"></div>
                    </div>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-1">
                </div>
                <div class="col-11">
                    <div class="row">
                        <div class="col-6">
                            <p class="text-muted m-0">Shipping</p>
                            <p class="text-muted">Ground shipping (3-5 business days)</p>
                        </div>
                        <div class="col-6 text-end">
                            <p class="text-muted">$5.00</p>
                        </div>
                        <div class="bordered-element"></div>
                    </div>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-1">
                </div>
                <div class="col-11">
                    <div class="row">
                        <div class="col-6">
                            <p class="dark">Total due</p>
                        </div>
                        <div class="col-6 text-end">
                            <p class="dark">$134.00</p>
                        </div>
                        <div class="bordered-element"></div>
                    </div>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-1"></div>
                <div class="col-11">
                    <div class="row">
                        <form  id="paymentcouponForm" [formGroup]="paymentcouponForm" name="paymentcouponForm"method="POST">
                        <div class="input-group mt-2" *ngIf="showCouponInput">
                            <input id="coupon-input" type="text" class="form-control coupon-form" name="msg" placeholder="Enter Coupon Code" formControlName="coupon_code">
                            <span class="input-group-text apply" (click)="applyCoupon()">APPLY</span>
                        </div>
                        </form>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-1"></div>
                <div class="col-11">
                    <div class="card mt-2" *ngIf="showCouponCard">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-6">
                                    <h4 class="text m-0 dark">
                                        '{{ paymentcouponForm.controls['coupon_code'].value }}' applied
                                    </h4>
                                    <p class="m-0"><span class="text dark"><i class="fa fa-check"></i> ₹75 </span>coupon savings</p>
                                </div>
                                <div class="col-6 text-end">
                                    <p class="text dark" (click)="removeCoupon()">Remove</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <button type="button" class="btn btn-primary btn-lg mt-2" onclick="makePayment()">
                        <i class="fas fa-credit-card"></i> Make Payment
                    </button>
                </div>

            <div class="text-center mt-5">
               <p class="m-0">Powered by <span class="dark">Direkt</span></p>
                <a href="terms-of-use" class="text">Terms</a> | <a href="privacy-policy" class="text">Privacy</a>
              </div>
        </div>
    </div>
</div>